import { SELLER_PACKAGE_VERSION } from "../../constants/seller-package-constants";

const parseSellerPackageDetails = (reportData, sellerPackageEligibility) => {
    const { sellerPackageDetails = {}, sellerPackageDetailsV2 = {}, ...rest } = reportData || {};
    const {
        auctionVariant = "",
        eligible = false,
        variant = ""
    } = sellerPackageEligibility || {};

    const sellerPackage = sellerPackageDetailsV2 || sellerPackageDetails || {};
    const { enabledForSell } = sellerPackageDetailsV2 || {};
    const isSellerPackageEligible = enabledForSell && eligible;

    return {
        ...rest,
        auctionVariant,
        sellerPackageDetails: {
            ...sellerPackage,
            isSellerPackageEligible, //to be used only for v2
            sellerPackageVersion: (isSellerPackageEligible || sellerPackageDetailsV2 !== null) ? SELLER_PACKAGE_VERSION.V2 : SELLER_PACKAGE_VERSION.V1,
            sellerPackageType: variant
        }
    };
};

export default parseSellerPackageDetails;
